import MenubarView from './MenubarView'
import Iframe from 'react-iframe'
import { useEffect} from 'react';
import { authWithBackend } from './AuthWithBackend.js';


const WHView = () => {

    useEffect(() => {
        authWithBackend()
    }, [])

    const mystyle = {
        height: "100%",
        width: "100%",
        position: 'relative'
    };
    return (
    
        <div style={mystyle}>
            <MenubarView/>   
            <Iframe url="https://amreporting.sevtekin.com/public/dashboard/563d0d47-e361-4e77-b09e-dc8821a2a848"
            width="100%"
            height="1200"
            position= "relative"
            frameBorder="0"
            />
        </div>
    );
}
export default WHView





       




    
 